export default "/icon-nav-home.svg";